module.exports = __webpack_public_path__ + "img/beyond_logo.9186f40c.png";